/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import NotInformation from "../../../../../../components/NotInformation";
import React from "react";
import {DocumentationFormApp} from "../Functionality/DocumentationFormApp";
import {FIELD_TYPE, sortListFieldType} from "../../../Type/Model/Model";

const DocumentationForm = ({ getInvitationById, data, handleChange, emptyFields, t ,photoPickerList,
                               setPhotoPickerList, isValidData}) => {
    const {
        fieldsForm,
        fieldsFormDocument ,
        fieldsFormCheckBox,
    } = DocumentationFormApp({
        photoPickerList,
        setPhotoPickerList
    });

    const fields = sortListFieldType(getInvitationById?.fields || []);

    return (
        <>
            {fields.length > 0 ? (
                <div className="row background-general-00 box-shadow-primary-900-opacity-10 p-24px border-radius-8px">
                    {fields.filter(field => field.fieldType !== FIELD_TYPE.DOCUMENT.name && field.fieldType !== FIELD_TYPE.CHECKBOX.name).map(field => (
                            <>
                                <div key={field.fieldId} className="col-12-sm col-lg-6 col-xl-6">
                                    {fieldsForm(field, data, handleChange, emptyFields, isValidData)}
                                </div>
                            </>
                        ))}
                    <div className={"col-12"}/>
                    {fields.filter(field => field.fieldType === FIELD_TYPE.CHECKBOX.name).map(field => (
                            <>
                                <div key={field.fieldId} className="col-12">
                                    {fieldsFormCheckBox(field, data, handleChange, emptyFields)}
                                </div>

                            </>

                        ))}
                    <div className={"col-12 mb-29px"}/>
                    {photoPickerList.map(field => (
                        <div key={field.fieldId} className="col-12-sm col-lg-12 col-xl-12">
                            {fieldsFormDocument(field, emptyFields)}
                        </div>
                    ))}
                </div>
            ) : (
                <NotInformation card={false} text={t('no_documentation')} />
            )}
        </>
    );
};

export default DocumentationForm;
